import { combineReducers } from 'redux'

import acceptCookies from './cookieAccept/reducer'
import auth from './auth/reducer'
import student from './student/reducer'
import showGuide from './showGuide/reducer'
import showInformation from './showInformation/reducer'
import recentView from './recentView/reducer'
import theme from './theme/reducer'
import subscription from './subscription/reducer'
import learningCourses from './learningCourses/reducer'
import toolsMenuInfo from './showToolsMenuInfo/reducer'
import dashboard from './dashboard/reducer'
import posthog from './posthog/reducer'
import studyPlan from './studyPlan/reducer'
import timer from './timer/reducer'
import tour from './tour/reducer'

const rootReducer = combineReducers({
  acceptCookies,
  auth,
  student,
  showGuide,
  showInformation,
  recentView,
  theme,
  subscription,
  learningCourses,
  toolsMenuInfo,
  dashboard,
  posthog,
  studyPlan,
  timer,
  tour,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
